// extracted by mini-css-extract-plugin
export default {"section":"matching_section__Ufqsu","section__title":"matching_section__title__7uKh1","section__text":"matching_section__text__VF7pr","section__btn":"matching_section__btn__3mpTY"};